import React from 'react'
import PropTypes from 'prop-types'

const RefinanceDisclosure = ({
  isRefinance,
  counter
}) => {
  if (!isRefinance) return <></>
  return (<p>
    {counter++}. When you refinance, this will pay off your prior loan balance.
    Any funds over the prior loan balance will be deposited as soon as the next business
    day. For example, if your current loan balance is $1,000 and you qualify for a $2,000
    loan $1,000 will pay off your prior loan balance and the remaining $1,000 will be
    deposited into your account.
  </p>)
}

RefinanceDisclosure.propTypes = {
  counter: PropTypes.number.isRequired,
  isRefinance: PropTypes.bool.isRequired
}

export default RefinanceDisclosure
